<template>
  <div class="update-subscription-payment" v-if="invoice">
    <div class="message">
      <h2>We had trouble renewing your subscription</h2>
      <p>
        We tried to collect the following payment on
        {{ invoice.charge_attempt.created | moment("Do MMM YYYY") }} but there
        was a problem charging your card ending in
        {{ invoice.charge_attempt.last4 }}.
      </p>

      <p><strong>Response from payment system: </strong>{{ invoice.charge_attempt.reason }}</p>

      <p>
        Please check your payment details and try again
        <strong>
          within the next {{ retryWindow | moment("from", "now", true) }}
        </strong>
        to maintain access or visit your
        <a href="/settings/billing">Billing & Payment</a> settings page for more
        options.
      </p>
    </div>

    <p>{{ invoice.description }}</p>

    <retry-or-edit-payment 
    :invoice="invoice"
    display-amount-due
    @done="done">
    </retry-or-edit-payment>
  </div>
  <spinner v-else />
</template>

<style lang="less" scoped>
.update-subscription-payment {
  max-width: 600px;

  .message {
    border-bottom: solid #ccc 1.5px;
    h2,
    strong {
      font-weight: bold;
    }
    &,
    h2 {
      margin-bottom: 1.5em;
    }
  }

  .spinner::v-deep {
    height: 1.7em;
    width: 1.7em;
    vertical-align: middle;
    margin-left: 5px;
  }
}

.spinner /deep/.spin-element {
  border-top-color: #ccc;
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert";
import { mapGetters } from "vuex";
import Spinner from "@/common/components/Spinner";
import RetryOrEditPayment from "@/settings/RetryOrEditPayment";

export default {
  components: { Spinner, RetryOrEditPayment },
  computed: {
    retryWindow() {
      return this.$moment(this.invoice.charge_attempt.created).add("7", "days");
    },
    ...mapGetters(["currentEdition", "currentUser"]),
  },
  data() {
    return {
      stripeOptions: null,
      editing: false,
      retrying: false,
      success: false,
      error: false,
      invoice: null,
    };
  },
  async mounted() {
    let invoiceId = this.currentUser.failed_renewal.invoice_id;
    let invoiceResponse = await axios.get(`/api/billing/invoices/${invoiceId}`);
    this.invoice = invoiceResponse.data;
  },
  methods: {
    done() {
      this.$emit("dismiss");
    }
  },
};
</script>
